import queryString from 'query-string';
import constants from 'Constants';
import * as api from 'Api';
import * as utils from 'Utils';


export function loadReperksWidgetCustomStyles(pageStore) {
  let el = pageStore.el;
  if (!el) return;
  updateAppElementStyles(pageStore);

  const customCssStyles = pageStore.widgetConfig.css.customCssStyles;
  const cssClasses = pageStore.widgetConfig.css.cssClasses;

  let elementId = `ov_app_reperks_widget_styles_${pageStore.id}`;
  let existingTag = document.getElementById(elementId);
  if (existingTag) existingTag.remove();

  let styles = require('containers/ReperksWidget/styles').default;
  let innerHTML = styles;
  if (utils.isProduction()) innerHTML = pageStore.cssStyles || "";

  let tag = document.createElement('style');
  tag.id = elementId;
  tag.innerHTML = innerHTML;
  el.after(tag);

  // custom css styles
  if (customCssStyles) {
    elementId = `ov_app_reperks_widget_custom_styles_${pageStore.id}`;
    existingTag = document.getElementById(elementId);
    if (existingTag) existingTag.remove();

    tag = document.createElement('style');
    tag.id = elementId;
    tag.innerHTML = customCssStyles;
    el.after(tag);
  }

  // add css classes
  if (cssClasses && cssClasses.length) {
    cssClasses.forEach((cssClass) => {
      if (el.classList.contains(cssClass)) return;
      el.classList.add(cssClass);
    })
  }
}

export function updateAppElementStyles(pageStore) {
  const el = pageStore.el;
  if (!el) return;

  if (pageStore.display) {
    el.style.display = "block";
  } else {
    el.style.display = "none";
  }
}

export function onReadyWidget(pageStore) {
  const qs = queryString.parse(window.location.search);
  const ovLink = qs['ov-reperks-link'];

  if (ovLink === 'home') {
    pageStore.switchNavStoreRewards();
  }

  if (ovLink === 'store-rewards') {
    pageStore.switchNavStoreRewards();
  }

  if (ovLink === 'earning-points') {
    pageStore.switchNavEarningPoints();
  }

  if (ovLink === 'activities') {
    pageStore.switchNavActivities();
  }

  let onHashChange = () => {
    if (window.location.hash === '#ov-reperks-home') {
      pageStore.switchNavStoreRewards();
    }

    if (window.location.hash === '#ov-reperks-store-rewards') {
      pageStore.switchNavStoreRewards();
    }

    if (window.location.hash === '#ov-reperks-earning-points') {
      pageStore.switchNavEarningPoints();
    }

    if (window.location.hash === '#ov-reperks-activities') {
      pageStore.switchNavActivities();
    }
  }

  onHashChange();
  utils.attachHashChangeEvent();
  window.addEventListener('ovhashchange', () => {
    onHashChange();
  });
}
